<template >
  <div class="learnDialog">
    <el-dialog :title="title" :visible.sync="learnDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="learnForm" :model="learnForm"  label-width="100px" :rules="rules">
        <el-form-item label="学段名"  class="is-required" prop="name" >
          <el-input v-model.trim="learnForm.name" maxlength="32" placeholder="请输入学段名..." ></el-input>
        </el-form-item>
        <el-form-item label="学段排序值"  class="is-required" prop="ordinal" >
          <el-input v-model.trim="learnForm.ordinal" placeholder="请输入学段排序值..." maxlength="9"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="learnDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import learnService from '@/service/learnService'
export default {
  props: {
    id: {
      type: Number
    },
    rowData: Object,
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      title: '新增学段名',
      loading: false,
      learnForm: {
        id: '',
        name: '',
        ordinal: '',
        shortName: '',
        used: false,
        value: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入学段名', trigger: ['blur', 'change']}
        ],
        ordinal: [
          {required: true, message: '请输入序列号', trigger: 'blur'},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      this.$refs.learnForm.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            await learnService.save(this.learnForm)
            // 重置表单
            // this.$refs.learnForm.resetFields()
            Object.keys(this.learnForm).forEach(key => this.learnForm[key] = '')
            this.$emit('success')
            this.loading = false
            this.learnDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    learnDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.learnForm) {          
          Object.keys(this.learnForm).forEach(key => this.learnForm[key] = '')
          this.$nextTick(()=>{
            this.$refs.learnForm.clearValidate()
          })          
        }
        // 加载初始化数据
        if (this.$props.id) {
          this.title = '编辑学段'
          this.learnForm = {
            id: this.$props.rowData && this.$props.rowData.id,
            name: this.$props.rowData && this.$props.rowData.name,
            ordinal: this.$props.rowData && this.$props.rowData.ordinal,
            value: this.$props.rowData && this.$props.rowData.value
          }
        } else {
          this.learnForm.name = ''
          this.title = '新增学段'
        }
      }
    }
  },
  computed: {
    learnDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }

}
</script>
<style scoped>
  .learnDialog .el-input{
    width:80%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/learn-manage/edit-dialog/index.vue